import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fullscreen",
  "use": "fullscreen-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"fullscreen\"><path fill-rule=\"evenodd\" d=\"M9.5 16h-6a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1Zm-1.354-4.854-5 5a.5.5 0 1 0 .708.708l5-5a.5.5 0 1 0-.708-.708ZM15 5.707V10.5a.5.5 0 0 0 1 0v-6a.498.498 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793l-4.147 4.146a.5.5 0 1 0 .708.708L15 5.707ZM4 16.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol